import { useCallback, useEffect, useState } from 'react';
import WalletConnector from '../connectors/walletconnect';
import { NetworkType } from '../utils/constants';

export function useWalletConnect(connectedNetwork: NetworkType | undefined) {
  const [hashconnectConnectorInstance, setHashconnectConnectorInstance] =
    useState<WalletConnector>();
  const [connected, setConnected] = useState(false);
  const [accountId, setAccountId] = useState(localStorage.getItem('accountId') || '');
  const [isPairing, setIsPairing] = useState(false);
  const [isHashPackExtensionAvailable, setIsHashPackExtensionAvailable] = useState(false);

  useEffect(() => {
    const initHashconnectConnector = async (network: NetworkType) => {
      try {
        const walletConnector = new WalletConnector(
          setAccountId,
          setConnected,
          setIsHashPackExtensionAvailable,
        );
        await walletConnector.initHashconnect(network);
        setHashconnectConnectorInstance(walletConnector);
      } catch (error) {
        console.error('Failed to initialize wallet connector:', error);
        const walletConnector = new WalletConnector(
          setAccountId,
          setConnected,
          setIsHashPackExtensionAvailable,
        );
        setHashconnectConnectorInstance(walletConnector);
      }
    };

    if (connectedNetwork) {
      initHashconnectConnector(connectedNetwork);
    }
  }, [connectedNetwork]);

  useEffect(() => {
    if (accountId) {
      setIsPairing(false);
    }
  }, [accountId]);

  const connectWallet = useCallback(() => {
    setIsPairing(true);
    hashconnectConnectorInstance?.connectViaWalletConnect();
  }, [hashconnectConnectorInstance]);

  const connectViaWalletConnect = useCallback(() => {
    setIsPairing(true);
    hashconnectConnectorInstance?.connectViaWalletConnect();
  }, [hashconnectConnectorInstance]);

  const connectToHashPack = useCallback(() => {
    setIsPairing(true);
    hashconnectConnectorInstance?.connectToHashPackExtension().catch(error => {
      console.error('HashPack connection failed:', error);
      setIsPairing(false);
    });
  }, [hashconnectConnectorInstance]);

  const clearPairings = useCallback(() => {
    hashconnectConnectorInstance?.clearPairings();
    setAccountId('');
    setConnected(false);
  }, [hashconnectConnectorInstance]);

  return {
    hashconnectConnectorInstance,
    connected,
    accountId,
    setAccountId,
    isPairing,
    isHashPackExtensionAvailable,
    connectWallet,
    connectViaWalletConnect,
    connectToHashPack,
    clearPairings,
  };
}
